// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".component-form-wizard-step-header[data-v-706d8d4e]{margin-bottom:2.5rem}.component-form-wizard-step-header__title__optional[data-v-706d8d4e]{color:#bec5d0}.component-form-wizard-step-header__description[data-v-706d8d4e]{margin-top:.3rem;color:#51596c;max-width:560px;line-height:1.6}", ""]);
// Exports
module.exports = exports;
